export enum Grade {
  None = 'NONE',
  PreKindergarten = 'PRE_KINDERGARTEN',
  Kindergarten = 'KINDERGARTEN',
  First = 'FIRST',
  Second = 'SECOND',
  Third = 'THIRD',
  Fourth = 'FOURTH',
  Fifth = 'FIFTH',
  Sixth = 'SIXTH',
  Seventh = 'SEVENTH',
  Eighth = 'EIGHTH',
  Ninth = 'NINTH',
  Tenth = 'TENTH',
  Eleventh = 'ELEVENTH',
  Twelfth = 'TWELFTH',
  HigherEducation = 'HIGHER_EDUCATION',
  Adult = 'ADULT',
}
